import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';

import Link from 'common/components/LocalizedLink/LocalizedLink';
import styles from './NewsBoxSm.module.scss';
import { ANCHOR } from 'common/consts/common';
export default class NewsBoxSm extends Component {
  static defaultProps = {
    className: ''
  };

  static propTypes = {
    news: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      news: props.news
    };
  }

  currentLanguage = LanguageService.getLang();

  render() {
    const { className } = this.props;
    const { news } = this.state;

    return (
      <div className={`${styles.NewsBoxSm} ${className}`}>
        <Link
          to={`${ANCHOR.NEWS[this.currentLanguage]}/${news.category}/${
            news.slug
          }`}
        >
          <div
            className={styles.NewsBoxSmImage}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                news.photo
              )})`
            }}
          />
        </Link>
        <div className={styles.ContainerDetails}>
          <div className={styles.ContainerHeaderDetails}>
            <div className={styles.ContainerContactInfo}>
              <Link
                to={`${ANCHOR.NEWS[this.currentLanguage]}/${news.category}/${
                  news.slug
                }`}
              >
                <h4 className={styles.NewsBoxSmNameSpan}>{news.title}</h4>
              </Link>
              <span className={styles.NewsBoxSmDate}>
                {moment(news.publicationDate).format('LL')}
              </span>
              <p className={styles.NewsBoxSmDescription}>{news.intro}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/News/components/NewsBoxSm/NewsBoxSm.js